import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import BankAccount from "./BankAccount";
import ContributionPaymentAgreement from "./ContributionPaymentAgreement";
import Id from "./Id";
import ProofOfAddress from "./ProofOfAddress";
import ProofOfEligibility from "./ProofOfEligibility";
import SocialSecurityCertificate from "./SocialSecurityCertificate";
import StudentCertificate from "./StudentCertificate";

// ACORIS proof matrix (§7.2 — Justificatifs).
const generateProofForm = ({
  hasAdultChild,
  requiresEligibilityProof,
  requiresThirdPartyPayer,
}) => ({
  // Attestation de droit au régime (adhérent + conjoint + enfants).
  [SUBSCRIPTION_FORM_KEYS.PROOF.SOCIAL_SECURITY_CERTIFICATE]:
    SocialSecurityCertificate,

  // Pièces d'identité — adhérent, conjoint, tiers payeur, enfants majeurs.
  [SUBSCRIPTION_FORM_KEYS.PROOF.ID]: Id,

  // RIB cotisations (+ RIB Prestation si autres comptes).
  [SUBSCRIPTION_FORM_KEYS.PROOF.BANK_ACCOUNT]: BankAccount,

  // Justificatif de domicile (facultatif).
  [SUBSCRIPTION_FORM_KEYS.PROOF.PROOF_OF_ADDRESS]: ProofOfAddress,

  // Attestation sur l'honneur du tiers payeur.
  [SUBSCRIPTION_FORM_KEYS.PROOF.CONTRIBUTION_PAYMENT_AGREEMENT]:
    requiresThirdPartyPayer && ContributionPaymentAgreement,

  // Justificatif d'éligibilité (profil dépendant).
  [SUBSCRIPTION_FORM_KEYS.PROOF.PROOF_OF_ELIGIBILITY]:
    requiresEligibilityProof && ProofOfEligibility,

  // Certificat de scolarité (enfants ≥ 18 ans).
  [SUBSCRIPTION_FORM_KEYS.PROOF.STUDENT_CERTIFICATE]:
    hasAdultChild && StudentCertificate,
});

export default generateProofForm;
